import { render, staticRenderFns } from "./AccountOrder.vue?vue&type=template&id=771d8574&"
import script from "./AccountOrder.vue?vue&type=script&lang=js&"
export * from "./AccountOrder.vue?vue&type=script&lang=js&"
import style0 from "./AccountOrder.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports